// src/components/PrivacyDisclaimer.jsx
import React from "react";

export default function PrivacyDisclaimer() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-6 leading-relaxed text-sm px-4"
      aria-labelledby="privacy-main-heading"
    >
      {/* Privacy & Data Use */}
      <h2
        id="privacy-main-heading"
        className="text-lg font-bold text-green-400"
      >
        Privacy & Data Use
      </h2>
      <p>
        Dialectical Analysis Theory (DAT) captures <b>anonymous usage data</b>{" "}
        to improve system performance, research, and user experience. Basic
        interaction metrics, such as question type, response time, and usage
        frequency, may be collected.
      </p>
      <p>
        <b>All inputs are treated as confidential</b> and are not retained
        beyond system processing cycles. DAT does not store user-generated
        content for profiling, commercial targeting, or third-party
        distribution.
      </p>

      {/* Mental Health */}
      <h3 className="text-lg font-bold text-yellow-400">
        Mental Health and Wellbeing
      </h3>
      <p className="text-yellow-300">
        DAT is a cognitive reasoning tool. It is <b>not</b> a diagnostic
        instrument, therapeutic intervention, or substitute for professional
        mental health care.
      </p>
      <p className="text-yellow-300">
        Users experiencing distress, emotional difficulty, or crisis should seek
        immediate support from a qualified mental health professional, general
        practitioner, or appropriate crisis service.
      </p>
      <p className="text-yellow-300 italic">
        In Australia, immediate mental health support is available via:
        <br />
        Lifeline:{" "}
        <a href="tel:131114" className="underline">
          13 11 14
        </a>{" "}
        | Beyond Blue:{" "}
        <a href="tel:1300224636" className="underline">
          1300 22 4636
        </a>
      </p>

      {/* User Responsibility */}
      <h3 className="text-lg font-bold text-cyan-400">User Responsibility</h3>
      <p>
        By using DAT, you acknowledge that any conclusions or interpretations
        drawn from its output remain your responsibility. DAT is designed to
        clarify logical structure and epistemic assumptions—not to determine
        moral, clinical, or actionable outcomes.
      </p>
    </section>
  );
}
